import { Stack } from "@mui/material";
import { DynamicFormTabs } from "features/shared/components/dynamic-form/DynamicFormTabs";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import type { UseRoomSchedulesReturn } from "../hooks/useRoomSchedules";

import { ROOM_SCHEDULE_SUBTABS, type RoomScheduleHeatmapKey, type RoomScheduleSubtab } from "../model/scheduleTypes";
import { RoomScheduleHeatmapPanel } from "./RoomScheduleHeatmapPanel";

type RoomScheduleTabProps = {
  isPresetLoading?: boolean;
  schedulesState: UseRoomSchedulesReturn;
};

export const RoomScheduleTab = ({ isPresetLoading = false, schedulesState }: RoomScheduleTabProps) => {
  const { t } = useTranslation();
  const [activeSubtab, setActiveSubtab] = useState<RoomScheduleSubtab>(ROOM_SCHEDULE_SUBTABS[0]);
  const { editAsCustom, hasData, resolveGrid, schedules, setMode, updateSchedule } = schedulesState;

  const subtabs = useMemo(
    () =>
      ROOM_SCHEDULE_SUBTABS.map((name) => ({
        label: t(`TechnicalData.room.schedule.subtabs.${name}`),
        name,
      })),
    [t]
  );

  const activeKey = activeSubtab as RoomScheduleHeatmapKey;

  return (
    <Stack className="w-full min-w-0 flex-col gap-4">
      <DynamicFormTabs
        activeTabName={activeSubtab}
        className="mt-0 w-full flex-wrap !gap-4"
        onTabChange={(tabName) => setActiveSubtab(tabName as RoomScheduleSubtab)}
        tabs={subtabs}
      />
      <RoomScheduleHeatmapPanel
        grid={resolveGrid(activeKey)}
        hasData={hasData(activeKey)}
        isLoading={isPresetLoading && schedules[activeKey].mode === "realistic"}
        mode={schedules[activeKey].mode}
        onEdit={() => editAsCustom(activeKey)}
        onGridChange={(customGrid) => updateSchedule(activeKey, { customGrid })}
        onModeChange={(mode) => setMode(activeKey, mode)}
      />
    </Stack>
  );
};
